import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { hexToRgb } from 'embed/utils'

const styles = require('embed/styles/results')

interface BBBRatingProps {
  objectiveComplete: () => void
  rating: string | undefined
}

export const BBBRating: React.FunctionComponent<BBBRatingProps> = (props) => {
  const { rating } = props
  return rating ? (
    <ThemeConsumer>
      {({ borderRadiusSmall, colorPrimary, colorBorder, fontFamilyPrimary, fontFamilySecondary }) => (
        <div
          className={classnames(
            styles.label,
            css`
              display: flex;
              align-items: center;
              justify-content: center;
              padding-bottom: 10px;
            `,
          )}
        >
          <div
            className={css`
              font-family: ${fontFamilySecondary};
              margin-right: 5px;
            `}
          >
            <p>BBB Rating</p>
          </div>
          <div
            className={css`
              background-color: rgba(
                ${hexToRgb(colorPrimary)?.r},
                ${hexToRgb(colorPrimary)?.g},
                ${hexToRgb(colorPrimary)?.b},
                0.1
              );
              border-radius: ${borderRadiusSmall};
              border-color: ${colorBorder};
              font-family: ${fontFamilyPrimary};
              font-weight: bold;
              color: ${colorPrimary};
              padding: 3px;
            `}
          >
            <p>{rating}</p>
          </div>
        </div>
      )}
    </ThemeConsumer>
  ) : null
}
